import React from 'react';
const facts = [{
  value: '60+',
  label: 'Class plans, ready to teach',
  color: 'text-coral-deep'
}, {
  value: '6 + 5',
  label: 'Volumes & bonuses',
  color: 'text-indigo'
}, {
  value: '3',
  label: 'Levels for every skill',
  color: 'text-teal-deep'
}, {
  value: '3',
  label: 'Apparatus: silks, hoop, trapeze',
  color: 'text-amber-deep'
}];
export function SocialProofBar() {
  return <section className="w-full bg-white" data-id="element-357" data-mp="32iusavqivfts">
      <div className="max-w-6xl mx-auto px-5 py-10 sm:py-12" data-id="element-358" data-mp="32htewkm1ah8w">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-cloud-dark bg-cloud-dark sm:grid-cols-4" data-id="element-359" data-mp="2xji8ykyv0qvy">
          {facts.map(fact => <div key={fact.label} className="bg-white px-4 py-5 text-center" data-id="element-360" data-mp="2tk9flh7qev0x">
              <div className={`font-display text-4xl font-bold leading-none sm:text-5xl ${fact.color}`} data-id="element-361" data-mp="2oj26neturpso">{fact.value}</div>
              <div className="mt-1.5 text-[10px] font-semibold uppercase tracking-widest text-slate" data-id="element-362" data-mp="1i0wyboh7l5kc">{fact.label}</div>
            </div>)}
        </div>
      </div>
    </section>;
}